import { CardData } from "./CardData";

export class User {
  constructor() {
    this.cards = [];
  }
  ID?: string;
  email?: string;
  cards: CardData[];
}

export function isPremium(user: User): boolean
{
  return true
}

export function canPreviewAlphaFeatures(user: User): boolean
{
  console.log(JSON.stringify(user.ID))
  if(user.ID == "jaroslawweber@gmail.com") return true
  if(user.email == "test@gmail.com") return true
  return false
}